<script setup lang="ts">
import { ref, watch } from 'vue';
import TrademarkType from './components/trademark-type.vue';
import TrademarkImage from './components/trademark-image.vue';
import TrademarkWord from './components/trademark-word.vue';
import {useTrademarkStore} from '@/store/mark';
import {MarkType} from '@/core/interface/api-interface';
import ApplicationStepHeader from '@/components/common/application-step-header.vue';
import {storeToRefs} from 'pinia';
import {useApplicationStore} from '@/store/application';
// import { useNotification } from '@/composables/useNotification';

const trademarkStore = useTrademarkStore();
const {uploadedAsWordImage} = storeToRefs(trademarkStore);
const { hasValidation } = storeToRefs(useApplicationStore());
// const { showInfoNotification } = useNotification();

const markType = ref<MarkType | null>(trademarkStore.trademarkType);

watch(markType, (newValue) => {
    if (newValue === MarkType.WORDS_IMAGE) {
        uploadedAsWordImage.value = true;
    }

    // if (oldValue !== null && newValue !== null) {
    //     const typeText = newValue === MarkType.IMAGE ? 'Logo' : newValue === MarkType.WORDS ? 'Brand Name' : 'Logo with Name';
    //     showInfoNotification(`You have changed your trademark type selection. You're now protecting your ${typeText}`, 'error')
    // }
})

</script>

<template>
    <StfCard :success="trademarkStore.isTrademarkStepValid" :error="hasValidation && !trademarkStore.isTrademarkStepValid">
        <template #title>
            <ApplicationStepHeader title="Add Trademark" :help="true" help-title="Add Trademark">
                <template #help>
                    <div class="mb-2 stf-text-bold">You need to select the type of trademark you want to protect.</div>
                    <div class="mb-2"><span class="stf-text-bold">Choose 'Word'</span> to protect a brand name, slogan or word/combination of words.</div>
                    <div class="mb-2"><i>This option protects your words in all forms, styles, fonts, and colours.</i></div>
                    <div class="mb-2"><span class="stf-text-bold">Choose 'Logo'</span> to protect an image or logo, that doesn't incorporate any words or text.</div>
                    <div class="mb-2"><i>This option protects your logo in any colour.</i></div>
                    <div class="mb-2"><span class="stf-text-bold">Choose 'Logo with words'</span> to protect an image or logo that includes words.</div>
                    <div class="mb-2"><i>(for example, your brand name).</i></div>
                </template>
            </ApplicationStepHeader>
        </template>
        <template #content>
            <StfSubHeading>Select the type of trademark to protect:</StfSubHeading>
            <TrademarkType v-model="markType"/>
            <StfDivider v-if="markType != null"></StfDivider>
            <TrademarkImage v-if="markType == MarkType.IMAGE || markType == MarkType.WORDS_IMAGE"/>
            <TrademarkWord v-if="markType == MarkType.WORDS"/>
        </template>
    </StfCard>
</template>

<style scoped>

</style>
